export const GET_MY_ORDERS = 'GET_MY_ORDERS'
export const SET_MY_ORDERS = 'SET_MY_ORDERS'
export const GET_MY_ORDERS_GRID_COUNT = 'GET_MY_ORDERS_GRID_COUNT'
export const SET_MY_ORDERS_GRID_COUNT = 'SET_MY_ORDERS_GRID_COUNT'
export const EXPAND_COLLAPSE = 'EXPAND_COLLAPSE'
// export const GET_APPROVAL_TIMELINE_HISTORY = 'GET_APPROVAL_TIMELINE_HISTORY'
// export const SET_APPROVAL_TIMELINE_HISTORY = 'SET_APPROVAL_TIMELINE_HISTORY'
// export const GET_DRIVER_DETAILS = 'GET_DRIVER_DETAILS'
// export const SET_DRIVER_DETAILS = 'SET_DRIVER_DETAILS'
// export const GET_REQUEST_REASON = 'GET_REQUEST_REASON'
// export const SET_REQUEST_REASON = 'SET_REQUEST_REASON'
// export const GET_ASSIGNMENT_TYPE = 'GET_ASSIGNMENT_TYPE'
// export const SET_ASSIGNMENT_TYPE = 'SET_ASSIGNMENT_TYPE'
// export const GET_CAPITAL_EXPENDITURE = 'GET_CAPITAL_EXPENDITURE'
// export const SET_CAPITAL_EXPENDITURE = 'SET_CAPITAL_EXPENDITURE'
export const GET_ROW_DATA = 'GET_ROW_DATA'
export const GET_ACTION_COLUMN = 'GET_ACTION_COLUMN'